import { render, staticRenderFns } from "./promoPizzas.vue?vue&type=template&id=5f0bf081&scoped=true&lang=pug"
import script from "./promoPizzas.vue?vue&type=script&lang=js"
export * from "./promoPizzas.vue?vue&type=script&lang=js"
import style0 from "./promoPizzas.vue?vue&type=style&index=0&id=5f0bf081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0bf081",
  null
  
)

export default component.exports